import {useParams} from "react-router-dom";
import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import React, {useEffect} from "react";
import {Spin} from "antd";
import {useSupCouncilInformationController} from "../../controllers/supCouncilInfo-controller";

const SupCouncilItemPage = () => {
  const {id} = useParams()
  const {isLoading, getSupCouncilInfoItemData, selectedItem } = useSupCouncilInformationController()

  useEffect(() => {
    if (id) {
      getSupCouncilInfoItemData(id)
    }
  }, [id])


  return <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">
              {selectedItem?.title}
            </div>
          </div>
        }
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content">
      <div className="generalItemPage_body">
        {selectedItem?.fileLink ? (
          <iframe
            className="publicFileView_iframe"
            src={selectedItem.fileLink}
            title="Public Info Document"
          />
        ) : (
          <Spin spinning={isLoading} size="large"/>
        )}
      </div>
    </div>

  </>
}
export default SupCouncilItemPage